/* eslint-disable react/prop-types */
/* eslint-disable prettier/prettier */
import React, { useRef, createContext } from "react";
export const GlobalRefContext = createContext(undefined);

export const GlobalRefProvider = ({ children }) => {
    const calculatedPaymentValues = useRef({});
    const calculatedExpenseValues = useRef({});
    const calculatedCELGValues = useRef({});
    const sumFormulas = useRef({});
    const status = useRef({});

    const refs = {
        calculatedPaymentValues,
        calculatedExpenseValues,
        calculatedCELGValues,
        sumFormulas,
        status,
    };

    return refs ? (
        <GlobalRefContext.Provider value={refs}>{children}</GlobalRefContext.Provider>
    ) : null;
};
